import { Button, Icon } from '@hometap/htco-components';
import React from 'react';
import { useParams } from 'react-router-dom';
import './CalculatorButton.scss';
import { UnderwritingCalculatorOutputNode } from '../../types/types';
import { formatMontDayYearTimeWithTZ } from 'utils/dates';
import cx from 'classnames';

type CalculatorButtonProps = {
  latestUwCalculatorOutput?: UnderwritingCalculatorOutputNode | null;
};

export const CalculatorButton = ({ latestUwCalculatorOutput }: CalculatorButtonProps) => {
  const { trackId } = useParams();

  if (!trackId) {
    return null;
  }

  return (
    <div className="UWCalcBlock">
      <Button
        target="_blank"
        rel="noopener noreferrer"
        href={`/tracks/${trackId}/uw-calculator/`}
        theme="secondary"
        className="UWCalcButton"
        size="small"
      >
        <Icon name="calculator" />
      </Button>

      {latestUwCalculatorOutput && (
        <div>
          <div className="UWCalcStatus">
            <strong className="UWCalcStatusLabel">Status: </strong>
            <strong
              className={cx('UWCalcStatusValue', {
                isEligible: latestUwCalculatorOutput.eligibilityStatus,
              })}
            >
              {latestUwCalculatorOutput.eligibilityStatus ? 'Eligible' : 'Ineligible'}
            </strong>
          </div>
          <div className="UWCalcStatusDetails">
            <span>Last run: </span>
            <span>{formatMontDayYearTimeWithTZ(latestUwCalculatorOutput.createdAt)}</span>
          </div>
        </div>
      )}
    </div>
  );
};
